export interface RootModalNavigationItem {
    id: string;
    type: string;
}

interface HandleRootModalBeforeNavigateParams {
    modals: readonly RootModalNavigationItem[];
    type: string | null | undefined;
    cancel: () => void;
    closeModal: (id: string, value: false) => void;
    incrementAbortedOverlayCount: () => void;
    shouldIncrementAbortedOverlayCount: boolean;
}

export function handleRootModalBeforeNavigate({ modals, type, cancel, closeModal, incrementAbortedOverlayCount, shouldIncrementAbortedOverlayCount }: HandleRootModalBeforeNavigateParams) {
    const hasFullCustomModal = modals.some(modal => modal.type === 'fullcustom');
    const topModal = modals.at(-1);

    if (type === 'popstate' && hasFullCustomModal && topModal) {
        cancel();
        if (shouldIncrementAbortedOverlayCount) {
            incrementAbortedOverlayCount();
        }
        closeModal(topModal.id, false);
        return true;
    }

    modals.forEach(modal => {
        if (modal.type !== 'fullcustom') {
            closeModal(modal.id, false);
        }
    });

    return false;
}
